import { darken, lighten, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

export const ViewSnagStyle = makeStyles((theme: Theme) => ({
    root: {
        "& > div": {
            // backgroundColor: "#F9F9F9",
        },
    },
    header: {
        borderBottom: "1px dashed #ced4da",
        paddingBottom: "20px",
        marginBottom: "20px",
    },
    headerRowA: {
        backgroundColor: "#F9F9F9",
        borderBottom: "1px solid #CED4DA",
        display: "flex",
        justifyContent: "space-between",
        "& > div:first-child": {
            padding: "17px 9px 24px 9px",
        },
        "& > div:last-child": {
            paddingTop: "4px",
        },
    },
    headerRowB: {},
    headerRowC: {
        display: "flex",
        flexDirection: "column",
        padding: "0px 9px 0px 9px",
    },
    headerRowD: {
        display: "flex",
        flexDirection: "column",
    },
    resolvedSnagTitle: {
        "& > h5": {
            color: "#449B23 !important",
            paddingBottom: "5px !important",
        },
    },
    rejectedSnagTitle: {
        color: "#DC3545",
    },
    title: {
        padding: "10px 9px 0px 9px",
        "& > h5": {
            fontSize: "16px",
            fontWeight: "bold",
            textTransform: "uppercase",
        },
    },
    date: {
        "& > h5": {
            fontSize: "18px",
            fontWeight: "bold",
            textTransform: "uppercase",
            lineHeight: "22px",
            color: "#191919",
            letterSpacing: "-0.45px",
            paddingBottom: "40px",
        },
    },
    navSnag: {
        "& > button": {
            fontSize: "10px",
        },
    },
    navSnags: {},
    detailsTitle: {
        "& > h5": {
            fontSize: "14px",
            lineHeight: "17px",
            letterSpacing: "-0.21px",
            color: "#191919",
            fontWeight: "bold",
        },
    },
    details: {
        paddingTop: "10px",
        "& > p": {
            fontSize: "12px",
            textAlign: "justify",
        },
    },
    rejectedReason: {
        padding: "10px 10px 6px",
        "& > p": {
            fontSize: "12px",
            whiteSpace: "pre-wrap",
            color: "#DC3545",
        },
    },
    completedBy: {
        padding: "0px 0px 20px 0px",
        "& > h5": {
            fontSize: "14px",
            lineHeight: "15px",
            letterSpacing: "-0.21px",
            color: "#3C3C3B",
            fontWeight: "normal",
            "& > strong": {
                fontWeight: "bold",
            },
        },
    },
    selectionRow: {},
    textAreaRow: {},
    buttonRow: {},
    formControl: {},
    formInputControl: {},
    formTextAreaControl: {},
    submitButton: {},
    editRoot: {
        marginLeft: "20px",
        marginRight: "20px",
        paddingBottom: "20px",
        "& div.MuiFormControl-root": {
            marginBottom: "16px",
            width: "100%",
        },
        "& div.MuiOutlinedInput-multiline": {
            padding: "8px 10px",
            "& textarea": {
                minHeight: "70px",
            },
        },
        "& button": {
            width: "100%",
        },
    },
    deleteBtn: {
        marginTop: "10px",
        backgroundColor: "#3C3C3B",
    },
    saveBtn: {
        marginTop: "24px",
    },
    paddedBox: {
        "& h5": {
            fontSize: "14px",
            lineHeight: "17px",
            letterSpacing: "-0.21px",
            color: "#191919",
            fontWeight: "bold",
            marginBottom: "20px",
        },
    },
    attechedImagesRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: "15px",
        "& > div": {
            width: "130px",
            "& > img": {
                height: "100%",
                width: "100%",
                objectFit: "cover",
                borderRadius: "3px",
            },
            "& > p": {
                color: "#191919",
                fontSize: "12px",
                fontWeight: "normal",
                lineHeight: "15px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
            },
        },
    },

    linkTxt: {
        color: "#556ED1",
        textDecoration: "underline",
        "&:hover": {
            cursor: "pointer",
        },
    },
    backToSnags: {
        position: "absolute",
        top: "0px",
        left: "0",
        width: "100%",
        background: "#D0E6C7",
        display: "flex",
        alignItems: "center",
        paddingLeft: "95px",
        gap: "8px",
        "& .arrowIcon": {
            backgroundColor: "#449B23",
            height: "30px",
            width: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            cursor: "pointer",
            "& svg": {
                fontSize: "20px",
            },
        },
        "& > button": {
            fontSize: "12px",
            lineHeight: "18px",
            color: "#3C3C3B",
            background: "transparent",
            fontWeight: 700,
            letterSpacing: "-0.18px",
            textDecoration: "none",
            "&:hover": {
                color: "#3C3C3B",
                background: "transparent",
            },
        },
    },
    sectionHeader: {
        background: "#3C3C3B",
        padding: "12px 20px",
        fontSize: "21px",
        lineHeight: "25px",
        color: "#FFFFFF",
        fontWeight: "bold",
        alignItems: "center",
        marginTop: "26px !important",
        "& > h4": {
            fontSize: "21px",
            lineHeight: "25px",
            letterSpacing: "-0.53px",
            color: "#FFFFFF",
            opacity: 1,
            fontWeight: "bold",
            paddingBottom: "7px",
        },
        "& > p": {
            fontSize: "14px",
            lineHeight: "18px",
            color: "#fff",
            fontWeight: "normal",
            letterSpacing: "-0.21px",
        },
    },
    snagDetailsContainer: {
        gap: "60px",
        width: "auto",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        marginTop: "20px !important",
    },
    snagDetailBox: {
        background: "#fff",
        borderRadius: "3px",
        opacity: 1,
        width: "100%",
        border: "1px solid #ECECEC",
        padding: "20px",
        "&:last-child": {
            background: "#ECECEC",
            "& > .header": {
                background: "#ECECEC",
            },
        },
    },
    snagStatusContainer: { display: "flex", flexDirection: "column", gap: "10px" },
    snagStatusBox: { display: "flex", flexDirection: "column", gap: "10px" },
    statusBanner: {
        border: "1px solid #646464",
        opacity: 1,
        borderRadius: "3px",
        "& > div > h4": {
            fontWeight: "bold",
            textTransform: "uppercase",
        },
        "& > div > p": {
            fontSize: "12px",
        },
    },
    statusContent: { padding: "12px" },
    [theme.breakpoints.up("md")]: {
        headerRowA: {
            background: "none",
            borderBottom: "none",
            padding: "17px 9px 0px 9px",
            "& > div": {
                padding: "6px 9px 0px 9px !important",
            },
        },

        navSnag: {
            "& > button": {
                fontSize: "16px",
            },
        },

        selectionRow: {
            display: "flex",
            flex: "1",
            margin: "0 -15px",
            paddingBottom: "10px",
        },
        textAreaRow: {
            display: "flex",
            flex: "1",
            margin: "0 -15px",
            paddingBottom: "10px",
            "& > div": {
                flex: 1,
            },
        },
        buttonRow: {
            paddingTop: "8px",
            margin: "0 -15px",
        },
        formControl: {
            padding: "0 15px",
        },
        formInputControl: {
            minWidth: "285px !important",
        },
        formTextAreaControl: {
            minWidth: "100%",
        },
        deleteBtn: {
            margin: "0 15px",
            maxWidth: "255px",
        },
        saveBtn: {
            margin: "0 15px",
            maxWidth: "255px",
        },
        editRoot: {
            borderTop: "1px dashed #ced4da",
            padding: "30px 0",
            "& > form > div >  div.form-group > div": {
                backgroundColor: "#F9F9F9",
            },
        },
        rejectedReason: {
            padding: "0 10px",
            "& > p": {
                fontSize: "12px",
                whiteSpace: "pre-wrap",
                color: "#DC3545",
            },
        },
    },
    [theme.breakpoints.down("sm")]: {
        root: {
            backgroundColor: "#F5F5F5",
            height: "calc(100vh - 55px) !important",
            "& > div": {
                backgroundColor: "#F5F5F5",
            },
        },
        sectionHeader: {
            marginTop: "0px !important",
            borderRadius: "20px 20px 0 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 20px",
            boxShadow: "0px -3px 6px #00000029",
            "& > button": {
                padding: "0px",
                height: "22px",
                width: "20px",
                color: "#fff",
            },
        },
        mobileHeaderContent: {
            "& > h4": {
                fontSize: "14px",
                lineHeight: "17px",
                letterSpacing: "-0.21px",
                color: "#FFFFFF",
                fontWeight: "bold",
            },
            "& > p": {
                fontSize: "10px",
                lineHeight: "14px",
                letterSpacing: "-0.21px",
                color: "#FFFFFF",
                fontWeight: "normal",
            },
        },
        snagDetailsContainer: {
            marginTop: "0px !important",
            padding: "30px",
            display: "flex",
            flexDirection: "column-reverse",
            gap: "0",
        },
        snagDetailBox: {
            background: "transparent",
            borderRadius: "0px",
            border: "none",
            padding: "0px",
            "&:last-child": {
                background: "transparent",
                marginBottom: "20px",
                borderBottom: "solid 1px #707070",
                paddingBottom: "18px",
                "& > .header": {
                    background: "transparent",
                },
            },
        },
        snagStatusBox: {
            background: "transparent",
            marginBottom: "20px",
            borderBottom: "solid 1px #707070",
            paddingBottom: "18px",
            "& > .header": {
                background: "transparent",
            },
        },
        date: {
            "& > h5": {
                fontSize: "14px",
                fontWeight: "bold",
                letterSpacing: "-0.35px",
                paddingBottom: "15px",
            },
        },
        completedBy: {
            padding: "0px 0px 15px 0px",
            "& > h5": {
                fontSize: "10px",
                lineHeight: "12px",
            },
        },
        paddedBox: {
            "& h5": {
                fontSize: "12px",
                lineHeight: "16px",
                marginBottom: "12px",
            },
        },
    },
}));
